<div class="information-text">
        <!-- optional projected icon slot (allows passing an <svg> or component) -->
        <ng-content select="[info-icon]"></ng-content>

    <!-- fallback image when no projected icon is provided -->
    @if(!hasProjectedIcon){<img [src]="infoTextInput?.iconSrc" [alt]="infoTextInput?.iconAlt" [ngClass]="infoTextInput?.iconClass || 'info-icon'" />}

        <!-- projected content: allows links, spans, or multiple elements -->
        <ng-content></ng-content>

    <!-- fallback text if caller passes `text` input instead of projecting content -->
    @if(infoTextInput?.text){<span class="info-text-fallback">{{ infoTextInput?.text }}</span>}
</div>